<script setup>
import { computed } from 'vue'
import { useFooterContent } from '@/composables/useContent'

// Props (para permitir override desde componente padre)
const props = defineProps({
  footerData: {
    type: Object,
    default: null
  }
})

// Setup
const { footer, site, getCurrentYear, isLoading, error } = useFooterContent()

// Usar props si se pasan, sino usar contenido por defecto
const footerContent = computed(() => props.footerData || footer.value)
const siteContent = computed(() => site.value)
const currentYear = computed(() => getCurrentYear())
</script>

<template>
  <footer class="bg-light-border dark:bg-dark-calendar-bg py-10 mt-20 transition-colors duration-300">
    <!-- Loading State -->
    <div v-if="isLoading" class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center">
        <div class="animate-pulse">
          <div class="h-4 bg-light-border dark:bg-dark-border rounded w-64 mx-auto"></div>
        </div>
      </div>
    </div>

    <!-- Error State -->
    <div v-else-if="error" class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center text-red-500">
        <p>Error cargando footer: {{ error }}</p>
      </div>
    </div>

    <!-- Content -->
    <div v-else class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-light-text-secondary dark:text-dark-text-secondary">
      <p>&copy; {{ currentYear }} {{ footerContent.copyright.company }}. {{ footerContent.copyright.description }}</p>
      
      <!-- Enlaces adicionales del footer (si existen) -->
      <div v-if="footerContent.links && footerContent.links.length > 0" class="mt-4 flex justify-center space-x-4">
        <router-link 
          v-for="link in footerContent.links"
          :key="link.id"
          :to="link.path"
          class="text-sm text-light-text-secondary dark:text-dark-text-secondary hover:text-light-text-primary dark:hover:text-dark-text-primary transition-colors duration-150"
        >
          {{ link.label }}
        </router-link>
      </div>
    </div>
  </footer>
</template>

<style scoped>
/* Estilos específicos del footer si son necesarios */
</style>
